import { TextMap } from "../types";

const fr: TextMap = {
  choose_preferred_wallet: "Choisissez votre portefeuille préféré",
  connect_mobile_wallet: "Se connecter au portefeuille mobile",
  scan_qrcode_with_wallet: "Scannez le QR code avec un portefeuille compatible WalletConnect",
  connect: "Se connecter",
  // TODO: review following translations
  qrcode: "QR Code",
  mobile: "Mobile",
  copy_to_clipboard: "Copier",
  copied_to_clipboard: "Copié!",
};

export default fr;
